(() => {
  let activeTrigger = null;
  const mobileMedia = window.matchMedia('(max-width: 749px)');

  function getPanel(trigger) {
    const panelId = trigger?.getAttribute('aria-controls');
    return panelId ? document.getElementById(panelId) : null;
  }

  function closePanel() {
    if (!activeTrigger) return;

    const panel = getPanel(activeTrigger);
    if (panel) {
      panel.hidden = true;
      panel.removeAttribute('style');
    }

    activeTrigger.setAttribute('aria-expanded', 'false');
    activeTrigger = null;
  }

  function positionPanel() {
    const panel = getPanel(activeTrigger);
    if (!panel || panel.hidden || mobileMedia.matches) return;

    panel.style.visibility = 'hidden';
    panel.style.position = 'fixed';
    panel.style.left = '0';
    panel.style.top = '0';

    const triggerRect = activeTrigger.getBoundingClientRect();
    const panelRect = panel.getBoundingClientRect();
    const viewportPadding = 16;
    const gap = 8;
    const availableRight = window.innerWidth - triggerRect.right - viewportPadding;
    const availableLeft = triggerRect.left - viewportPadding;
    let left;
    let top = triggerRect.top + ((triggerRect.height - panelRect.height) / 2);

    if (availableRight >= panelRect.width + gap) {
      left = triggerRect.right + gap;
    } else if (availableLeft >= panelRect.width + gap) {
      left = triggerRect.left - panelRect.width - gap;
    } else {
      left = Math.min(
        Math.max(viewportPadding, triggerRect.left),
        window.innerWidth - panelRect.width - viewportPadding
      );
      top = triggerRect.bottom + gap;
    }

    top = Math.min(
      Math.max(viewportPadding, top),
      window.innerHeight - panelRect.height - viewportPadding
    );

    panel.style.left = `${Math.round(left)}px`;
    panel.style.top = `${Math.round(top)}px`;
    panel.style.visibility = 'visible';
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target?.closest('[data-sale-badge-info-trigger]');

    if (trigger) {
      const panel = getPanel(trigger);
      if (!panel) return;

      if (activeTrigger === trigger && !panel.hidden) {
        closePanel();
        trigger.focus();
        return;
      }

      closePanel();
      activeTrigger = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      if (!mobileMedia.matches) positionPanel();
      return;
    }

    if (!target?.closest('.sale-badge-info-panel')) closePanel();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !activeTrigger) return;

    const trigger = activeTrigger;
    closePanel();
    trigger.focus();
  });

  window.addEventListener('resize', positionPanel);
  window.addEventListener('scroll', positionPanel, true);

  const handleViewportChange = () => {
    const panel = getPanel(activeTrigger);
    if (!panel || panel.hidden) return;

    panel.removeAttribute('style');
    if (!mobileMedia.matches) positionPanel();
  };

  if (mobileMedia.addEventListener) {
    mobileMedia.addEventListener('change', handleViewportChange);
  } else {
    mobileMedia.addListener(handleViewportChange);
  }
})();
